import { useEntityFinderContext } from "../context/EntityFinderContext";
import { Resource } from "@/bryntum-lib/models/Resource";
import { useSwivuBryntumContext } from "@/react/hooks/useSwivuBryntumContext";
import { ENTITY_TYPES } from "@/other/constants/OtherKeys";

export const ResourceTab = () => {
  const { data, handleClose } = useEntityFinderContext();
  const { entityManager } = useSwivuBryntumContext();
  const resources = data as Resource[];

  const handleResourceClick = (resource: Resource) => {
    entityManager.openEntityManager({ entityType: ENTITY_TYPES.RESOURCE, entityId: resource.id });
    handleClose();
  };

  return (
    <div className="flex flex-col h-full overflow-auto bg-background">
      {resources.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-full text-muted-foreground p-8 text-center">
          <svg className="w-12 h-12 mb-4 opacity-40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
            />
          </svg>
          <p className="text-sm">No resources found</p>
        </div>
      ) : (
        <div className="space-y-3">
          {resources.map((resource, index) => (
            <div
              key={resource.id}
              onClick={() => handleResourceClick(resource)}
              className={`px-4 py-3 bg-card hover:opacity-90 cursor-pointer transition-all border-b border-border/40 last:border-b-0 rounded-md ${index === 0 ? "border-t-0" : ""}`}
            >
              <div className="font-medium text-foreground line-clamp-1">{resource.name || "N/A"}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
